import CostCenters from './CostCenters';

export default CostCenters;
